var _rect, _rect2, _path, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteKeyFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash-can_3_",
    "data-name": "trash-can (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.571,
    height: 10,
    viewBox: "0 0 8.571 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144612",
    "data-name": "Rectangle 144612",
    width: 0.714,
    height: 4.286,
    transform: "translate(2.857 3.571)",
    fill: "#e32a34"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144613",
    "data-name": "Rectangle 144613",
    width: 0.714,
    height: 4.286,
    transform: "translate(5 3.571)",
    fill: "#e32a34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21059",
    "data-name": "Path 21059",
    d: "M4,6v.714h.714v7.143a.714.714,0,0,0,.714.714h5.714a.714.714,0,0,0,.714-.714V6.714h.714V6Zm1.429,7.857V6.714h5.714v7.143Z",
    transform: "translate(-4 -4.571)",
    fill: "#e32a34"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144614",
    "data-name": "Rectangle 144614",
    width: 2.857,
    height: 0.714,
    transform: "translate(2.857)",
    fill: "#e32a34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteKeyFrame);
export default __webpack_public_path__ + "static/media/DeleteKeyFrame.6a4ef8dca27e6edf4c3652c6166457fd.svg";
export { ForwardRef as ReactComponent };